import React from "react";
import { Box, Typography, Button, IconButton, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Close } from "@mui/icons-material";
import UploadIcon from "@mui/icons-material/Upload";
import CustomTextField from "../../components/FormElements/CustomTextField";
import OutlinedButton from "../../components/FormElements/Buttons/OutlinedButton";
import ContainedButton from "../../components/FormElements/Buttons/ContainedButton";
import { iconMap } from "./categoryIcons";

const CategoryFormDialog = ({ openDialog, handleCloseDialog, isEditMode, categoryType, handleCategoryTypeChange, categoryName, handleCategoryChange, handleOpenIconDialog, customIcon, selectedIcon, categoryHashtag, setCategoryHashtag, handleHashtagInputKeyDown, hashtags, handleRemoveHashtag, handleUpdateCategory, handleAddCategory }) => (
<>
      {/* Dialog for adding/editing categories */}
      <Dialog
        sx={{
          zIndex: 9,
          "& .MuiDialog-container .MuiPaper-elevation": {
            borderRadius: "8px",
            width: "420px",
          },
        }}
        open={openDialog}
        onClose={handleCloseDialog}
      >
        <Box sx={{ padding: "20px 16px 0" }}>
          <DialogTitle
            sx={{ padding: "0 0 15px", textAlign: "center", fontWeight: 700 }}
          >
            {isEditMode ? "Edit Category" : "Add Category"}
          </DialogTitle>
          <Typography sx={{ marginBottom: "10px" }}>Category Type</Typography>
          <Button
            onClick={() => handleCategoryTypeChange("Post")}
            variant="outlined"
            sx={{
              marginRight: "6px",
              height: "35px",
              fontSize: "14px",
              borderRadius: "6px",
              padding: "0 15px",
              fontWeight: 600,
              backgroundColor: categoryType === "Post" ? "#142C5C" : "white",
              color: categoryType === "Post" ? "white" : "#142C5C",
              border: "1px solid #142C5C",
              "&:hover": {
                backgroundColor: "#142C5C",
                color: "#ffffff",
                borderColor: "#142C5C",
              },
            }}
          >
            Post
          </Button>
          <Button
            onClick={() => handleCategoryTypeChange("Live")}
            variant="outlined"
            sx={{
              marginLeft: "6px",
              height: "35px",
              fontSize: "14px",
              borderRadius: "6px",
              padding: "5px 15px",
              fontWeight: 600,
              backgroundColor: categoryType === "Live" ? "#142C5C" : "white",
              color: categoryType === "Live" ? "white" : "#142C5C",
              border: "1px solid #142C5C",
              "&:hover": {
                color: "#ffffff",
                borderColor: "#142C5C",
                backgroundColor: "#142C5C",
              },
            }}
          >
            Live
          </Button>
        </Box>
        <DialogContent sx={{ padding: "10px 16px 0" }}>
          <Box display="flex" alignItems="center" mb={1}>
            <CustomTextField
              label="Title of the category"
              // variant="outlined"
              // fullWidth
              value={categoryName}
              onChange={handleCategoryChange}
              // margin="normal"
              inputProps={{
                pattern: "[a-zA-Z0-9 ]*",
                title: "Only letters, numbers, and spaces are allowed",
                style: { color: "black" },
              }}
              // sx={{
              //     '& .MuiOutlinedInput-root': {
              //         borderRadius: '6px',
              //         '& fieldset': {
              //             borderColor: 'grey',
              //         },
              //         '&:hover fieldset': {
              //             borderColor: '#142C5C',
              //         },
              //         '&.Mui-focused fieldset': {
              //             borderColor: '#142C5C',
              //         },
              //     },
              //     '& .MuiInputLabel-root': {
              //         color: 'grey',
              //     },
              //     '& .MuiInputLabel-root.Mui-focused': {
              //         color: '#142C5C',
              //     },
              // }}
            />
            <Box display="flex" alignItems="center" ml={1}>
              <Button
                onClick={handleOpenIconDialog}
                variant="contained"
                startIcon={<UploadIcon />}
                sx={{
                  flexShrink: 0,
                  width: "100px",
                  // margin: '8px 0 0',
                  backgroundColor: "#142C5C",
                  color: "#fff",
                  borderColor: "#0f2247",
                  "&:hover": {
                    backgroundColor: "#0f2247",
                  },
                  borderRadius: "6px",
                  fontSize: {
                    xs: "12px",
                    sm: "13px",
                    md: "13px",
                    lg: "14px",
                    xl: "14px",
                  },
                  height: "53px",
                }}
              >
                Upload
              </Button>
            </Box>
          </Box>

          {/* Conditional rendering of icon box */}
          {!customIcon && selectedIcon && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                border: "2px solid #142C5C",
                borderRadius: "4px",
                padding: 1,
                backgroundColor: "#f0f0f0",
                marginRight: 1,
                marginBottom: 1,
                width: "44px",
              }}
            >
              {iconMap[selectedIcon] ? (
                React.createElement(iconMap[selectedIcon], {
                  size: 24,
                  color: "black",
                })
              ) : (
                <img src={selectedIcon} alt="" width={25} />
              )}
            </Box>
          )}
          {customIcon && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                border: "2px solid #142C5C",
                borderRadius: "4px",
                padding: 1,
                backgroundColor: "#f0f0f0",
                marginRight: 1,
                marginBottom: 1,
                width: "44px",
              }}
            >
              <img src={customIcon?.url} alt="" width={25} />
            </Box>
          )}
          <CustomTextField
            label="Hashtag"
            // variant="outlined"
            // fullWidth
            value={categoryHashtag}
            onChange={(e) => setCategoryHashtag(e.target.value)}
            onKeyDown={handleHashtagInputKeyDown}
            // margin="normal"
            // sx={{
            //     margin: 0,
            //     '& .MuiOutlinedInput-root': {
            //         borderRadius: '6px',
            //         '& fieldset': {
            //             borderColor: 'grey',
            //         },
            //         '&:hover fieldset': {
            //             borderColor: '#142C5C',
            //         },
            //         '&.Mui-focused fieldset': {
            //             borderColor: '#142C5C',
            //         },
            //     },
            //     '& .MuiInputLabel-root': {
            //         color: 'grey',
            //     },
            //     '& input': {
            //         color: 'black',
            //     },
            //     '& .MuiInputLabel-root.Mui-focused': {
            //         color: '#142C5C',
            //     },
            // }}
          />
          <Box mt={2}>
            {hashtags.map((hashtag, index) => (
              <Button
                key={hashtag}
                onClick={() => handleRemoveHashtag(hashtag)}
                variant="outlined"
                size="small"
                sx={{
                  marginRight: 1,
                  marginBottom: 1,
                  fontSize: "12px",
                  borderRadius: "8px",
                  borderColor: "#142C5C",
                  color: "#142C5C",
                  fontWeight: 600,
                }}
              >
                #{hashtag}
                <IconButton size="small" edge="end">
                  <Close sx={{ color: "#142C5C", fontSize: "15px" }} />
                </IconButton>
              </Button>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "0 16px 20px" }}>
          <OutlinedButton onClick={handleCloseDialog} btnName={"Cancel"} />
          <ContainedButton
            onClick={() => {
              if (isEditMode) {
                handleUpdateCategory();
              } else {
                handleAddCategory();
              }
            }}
            btnName={isEditMode ? "Update" : "Add"}
          />
        </DialogActions>
      </Dialog>
</>
);

export default CategoryFormDialog;
